import { useSessionContext } from '@common/hooks';
import {
  EtablissementDeclarantDto,
  useDownloadOrganismeEtablissementGeneratedDeclarationMutation,
} from '@common/services';
import { DsfrModal, Form, SelectField } from '@common/ui';
import React, { useEffect, useRef, useState } from 'react';
import { z } from 'zod';
import { useAppDispatch } from '../../../hooks/store.hook';
import { dontNeedNewDeclaration } from '../../Dashboard/components/VerticalStepper/stores/dashboard-stepper.slice';

const DECLARANT_FORM_SCHEMA = z.object({ etablissementDeclarant: z.string() });

export const GenerateDeclarationModal = ({ dsfrModal, etablissements }: GenerateDeclarationModalProps) => {
  const dispatch = useAppDispatch();
  const buttonSubmitRef = useRef<HTMLButtonElement | null>(null);
  const [declarantId, setDeclarantId] = useState<string>('');

  const { organismeId } = useSessionContext();

  useEffect(() => {
    const declarantPrincipal = etablissements.find(({ principal }) => principal) ?? etablissements[0];
    if (!declarantPrincipal) return;

    setDeclarantId(declarantPrincipal.id.toString());
  }, [etablissements]);

  const [downloadDeclarationRessource, { isLoading: isDeclarationLoading }] = useDownloadOrganismeEtablissementGeneratedDeclarationMutation();

  const declarantsOptions = etablissements.map(({ denominationUsuelle, id }) => ({
    label: denominationUsuelle,
    value: id.toString(),
  }));

  const handleGenerate = () => {
    dispatch(dontNeedNewDeclaration());
    downloadDeclarationRessource({
      id: organismeId,
      etablissementId: Number(declarantId),
    });
  };

  return (
    <dsfrModal.Component title={'Génération de déclaration'}
                         size="large"
                         topAnchor={false}
                         buttons={[
                           {
                             children: 'ANNULER',
                             doClosesModal: true,
                             className: 'text-red-500!',
                             priority: 'tertiary',
                           },
                           {
                             children: 'TÉLÉCHARGER',
                             doClosesModal: false,
                             className: 'uppercase',
                             priority: 'primary',
                             onClick: () => buttonSubmitRef.current?.click(),
                             disabled: isDeclarationLoading,
                           },
                         ]}>

      <div className={'flex flex-col p-6'}>
        <div className={'flex flex-col gap-6'}>
          <Form
            onSubmit={handleGenerate}
            schema={DECLARANT_FORM_SCHEMA}
            buttonSubmitRef={buttonSubmitRef}>
            <SelectField name="etablissementDeclarant"
                         title="Établissement déclarant"
                         options={declarantsOptions}
                         value={declarantId}
                         onSelect={(value: string) => setDeclarantId(value)}
            />
          </Form>
        </div>
      </div>
    </dsfrModal.Component>
  );
};

interface GenerateDeclarationModalProps {
  dsfrModal: DsfrModal;
  etablissements: EtablissementDeclarantDto[];
}